import React, { useEffect, useState } from 'react'
import CheckboxField from '../../Common/Fields/CheckboxField'
import { LoadingButton } from '@mui/lab'
import { Button } from '@mui/material'
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function DocketColumns({ isLoading, setModal, formik }) {
    const [select, updateSelect] = useState(false)
    
    const handleSelectAll = () => {
        updateSelect(!select)
        if (!select) {
            Object.entries(formik.values).forEach(values => {
                formik.setFieldValue(values[0], true)
            });
        } else {
            Object.entries(formik.values).forEach(values => {
                formik.setFieldValue(values[0], false)
            });
        }
    }
    return (
        <div style={{ 
            fontSize: '13px',
            lineHeight: '1.4'
        }}>
            {/* Basic Information Section */}
            <div className="mb-2 p-2" style={{ 
                backgroundColor: '#fff', 
                borderRadius: '6px',
                border: '1px solid #e9ecef'
            }}>
                <h6 style={{ color: '#495057', marginBottom: '8px', fontWeight: '600', fontSize: '13px' }}>
                    Basic Information
                </h6>
                <div className='row g-2'>
                    <div className="col-md-3">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Circuit ID' name='circuit_id' options={['Circuit ID']} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Customer ID 1' name='customer_id' options={['CustID 1']} />
                        </div>
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Customer ID 2' name='customer_id_alt' options={['CustID 2']} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='3rd Party Docket' name='third_party_docket_no' options={['3rd Party Docket']} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='OFC Distance' name='ofc_distance' options={['Ofc. Distance']} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Location Information Section */}
            <div className="mb-2 p-2" style={{ 
                backgroundColor: '#fff', 
                borderRadius: '6px',
                border: '1px solid #e9ecef'
            }}>
                <h6 style={{ color: '#495057', marginBottom: '8px', fontWeight: '600', fontSize: '13px' }}>
                    Location Information
                </h6>
                <div className='row g-2'>
                    <div className="col-md-4">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Location A' name='location_a' options={['Location A']} />
                        </div>
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Location B' name='location_b' options={['Location B']} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Address A' name='address_a' options={['Address A']} />
                        </div>
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Address B' name='address_b' options={['Address B']} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Office Name' name='office_name' options={['Office Name']} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Team & Status Information Section */}
            <div className="mb-2 p-2" style={{ 
                backgroundColor: '#fff', 
                borderRadius: '6px',
                border: '1px solid #e9ecef'
            }}>
                <h6 style={{ color: '#495057', marginBottom: '8px', fontWeight: '600', fontSize: '13px' }}>
                    Team & Status Information
                </h6>
                <div className='row g-2'>
                    <div className="col-md-3">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Fiber Team Leader' name='ftl' options={['FTL']} />
                        </div>
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Technician' name='technician' options={['Technician']} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Hirer' name='hirer' options={['Hirer']} />
                        </div>
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Problem Description' name='problem' options={['Problem']} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Status' name='status' options={['Status']} />
                        </div>
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Actions' name='actions' options={['Actions']} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Created Date' name='created_at' options={['Created At']} />
                        </div>
                        <div style={{ marginBottom: '6px' }}>
                            <CheckboxField label='Last Updated' name='updated_at' options={['Last Updated']} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Quick Actions Section */}
            <div className="mb-2 p-2" style={{ 
                backgroundColor: '#f8f9fa', 
                borderRadius: '6px',
                border: '1px solid #e9ecef'
            }}>
                <div className='row g-2'>
                    <div className="col-md-6">
                        <div style={{
                            padding: '8px',
                            backgroundColor: '#fff',
                            borderRadius: '4px',
                            border: '1px solid #ced4da'
                        }}>
                            <FormControlLabel
                                control={<Checkbox 
                                    checked={select} 
                                    style={{ color: '#007bff' }}
                                />}
                                label={<span style={{ fontWeight: '500', color: '#495057', fontSize: '13px' }}>Select All Columns</span>}
                                name='select_all'
                                value={true}
                                onChange={handleSelectAll}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="d-flex flex-wrap gap-2 mt-2 pt-2" style={{ 
                borderTop: '1px solid #e9ecef'
            }}>
                <LoadingButton
                    loading={isLoading}
                    type="submit"
                    variant="contained"
                    size="small"
                    startIcon={<span className="material-icons-sharp" style={{ fontSize: '16px' }}>done</span>}
                    style={{
                        borderRadius: '4px',
                        padding: '6px 12px',
                        fontSize: '13px',
                        fontWeight: '600',
                        textTransform: 'none',
                        backgroundColor: '#28a745',
                        boxShadow: '0 1px 4px rgba(40, 167, 69, 0.3)'
                    }}
                >
                    Apply
                </LoadingButton>
                <Button 
                    variant="text" 
                    size="small"
                    startIcon={<span className="material-icons-sharp" style={{ fontSize: '16px' }}>close</span>}
                    onClick={() => setModal(false)}
                    style={{
                        borderRadius: '4px',
                        padding: '6px 12px',
                        fontSize: '13px',
                        fontWeight: '500',
                        textTransform: 'none',
                        color: '#6c757d'
                    }}
                >
                    Cancel
                </Button>
            </div>
        </div>
    )
}
